import { Pipe, PipeTransform } from '@angular/core';
import moment_ from 'moment-timezone';

const moment = moment_;

@Pipe({
  name: 'formatEpoch',
  standalone: false,
})
export class FormatEpochPipe implements PipeTransform {
  transform(timestamp: string, curentTime: number): string {
    if (!timestamp) {
      return '';
    }

    const diffMs = curentTime - Number(timestamp);
    const duration = moment.duration(diffMs);

    const hours = String(Math.floor(duration.asHours())).padStart(2, '0');
    const minutes = String(duration.minutes()).padStart(2, '0');
    const seconds = String(duration.seconds()).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }
}
